// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__2nS-D","filesListContainer":"PosDisputesFiles_filesListContainer__2ZNV3","filesButton":"PosDisputesFiles_filesButton__2QM8k"};